import type { BaseKeyFunction } from "../../../lib/types/baseKeyFunction";

export const keySubscriptions: BaseKeyFunction = () => ["subscriptions"];

export const keySubscription: BaseKeyFunction = () => ["subscription"];

export const keyCancelFlow: BaseKeyFunction = () => [
  "subscription",
  "cancellation",
];
